import type { Dispatch, SetStateAction } from 'react'
import { useEffect } from 'react'

import type { InvoiceOrEstimate } from '~/types'

import { invoiceFromStateIndicatesEstimate } from './invoiceBodyDisplayUtils'

/**
 * Keeps local `isEstimate` aligned with loaded invoice data when the server returns a type.
 */
export function useSyncEstimateFromInvoiceState(
  invoiceFromState: InvoiceOrEstimate | null | undefined,
  setIsEstimate: Dispatch<SetStateAction<boolean>>,
): void {
  useEffect(() => {
    if (invoiceFromState) {
      setIsEstimate(invoiceFromStateIndicatesEstimate(invoiceFromState))
    }
    // Match InvoiceDialog: only re-sync when `invoiceFromState.type` changes.
  }, [invoiceFromState?.type])
}
